<template>
  <div>
    <div class="bg-FF p-20">
      <div class="flex row-between col-center p-t-10 m-b-24 font-28 cor-66">
        <div @click="isShowPopup(year,'year')">
          {{ queryParams.year }}
          <van-icon class="m-l-6" name="play" style="transform: rotate(90deg);" />
        </div>
        <div @click="isShowPopup(ywdy,'unitId')">
          {{ queryParams.unitName }}
          <van-icon class="m-l-6" name="play" style="transform: rotate(90deg);" />
        </div>

        <template>
          <!--年-->
          <van-popup v-model="year.show" get-container="body" position="bottom">
            <van-nav-bar left-text="取消" right-text="确定" title="选择时间" @click-left="year.show = false" @click-right="popupConfirm('year')" />
            <van-picker ref="year" :columns="year.filteredData" value-key="label" @cancel="year.show = false" />
          </van-popup>
          <!--业务单元-->
          <van-popup v-model="ywdy.show" get-container="body" position="bottom">
            <van-nav-bar left-text="取消" right-text="确定" title="请选择业务单元" @click-left="ywdy.show = false" @click-right="popupConfirm('ywdy', ywdy)" />
            <van-search v-model="ywdy.filterText" clearable shape="round" @input="popupSearch($event, ywdy)" />
            <van-picker ref="ywdy" :columns="ywdy.filteredData" value-key="label" @cancel="ywdy.show = false" />
          </van-popup>
        </template>
      </div>

      <div class="staff-info width-100 p-12 bg-D0D9FF flex row-around col-center b-r-8">
        <div v-for="(item, index) in tabs" :key="index" :class="{active: activeIndex === index }" class="font-28 p-t-8 p-b-8 p-l-58 p-r-58 cor-99" @click="selectTab(index)">{{ item.title }}</div>
      </div>
    </div>

    <!--内容区域-->
    <div class="p-t-12 p-b-20 p-l-20 p-r-20">
      <div class="tab-content">
        <OverviewBusinessSituation v-if="activeIndex === 0" :statisticsData="jyqkData" :paramYear="queryParams.year" />
        <ContractDebtStatistics v-if="activeIndex === 1" :statisticsData="htqkData" />
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin/flow'
import moment from "moment";
import OverviewBusinessSituation from '@/views/operateKanban/components/OverviewBusinessSituation.vue'
import ContractDebtStatistics from '@/views/operateKanban/components/ContractDebtStatistics.vue'
import {methodGetApi} from "@/api/publicApi";

export default {
  name: 'operateKanbanIndex',
  mixins: [mixin],
  components: {
    OverviewBusinessSituation,
    ContractDebtStatistics,
  },
  data() {
    return {
      moment,
      activeIndex: 0,
      tabs: [
        {
          title: '经营情况概览',
          apiUrl: '/manage/BI/businessPerformance',
          dataKey: 'jyqkData'
        },
        {
          title: '合同与欠款统计',
          apiUrl: '/manage/BI/contractAndDebtInfo',
          dataKey: 'htqkData'
        }
      ],
      jyqkData: {},
      htqkData: {},
      queryParams: {
        year: moment().format('YYYY'),
        unitName: '全部业务单元',
        unitId: '',
      },
      touchStartX: 0,
      touchStartTime: 0,
      isMouseDown: false,
      year: {
        show: false,
        filteredData: this.getYear(),
      },
      ywdy: {
        data: [{
          unitName: '全部业务单元',
          unitId: '',
        }],
        show: false,
        filteredData: ['全部业务单元'],
        filterText: '',
      },
    }
  },
  created() {
    this.getYear()
    this.getBusUnitData()

    this.getList('/manage/BI/businessPerformance')
  },
  methods: {
    selectTab(index) {
      this.activeIndex = index;
      this.getList(this.tabs[index].apiUrl)
    },
    getList(url) {
      methodGetApi(url, this.queryParams).then(res => {
        if (this.activeIndex == 0) {
          this.jyqkData = res.data
        } else {
          this.htqkData = res.data
        }
      })
    },
    getBusUnitData() {
      methodGetApi('/system/sysBusUnit/list', {statisticsFlag: 1}).then(res => {
        const data = res.data.map(item => {
          return item.unitName
        })
        this.ywdy.data = res.data
        this.ywdy.filteredData = [...this.ywdy.filteredData, ...data]
      })
    },
    getYear() {
      const currentYear = new Date().getFullYear()
      const halfYearList = []
      for (let i = currentYear - 5; i <= currentYear + 5; i++) {
        halfYearList.push(i)
      }
      return halfYearList
    },
    popupSearch(text, deploy) {
      const filteredNames = deploy.data.filter(item => {
        return item.unitName.includes(text);
      }).map(item => item.unitName);

      deploy.filteredData = filteredNames;
    },
    popupConfirm(field, props) {
      const item = this.$refs[field].getValues()[0]
      this.$set(this[field], 'show', false)
      if (props) {
        const unitId = props.data.find(i => i.unitName === item)?.unitId
        this.$set(this.queryParams, 'unitId', unitId)
        this.$set(this.queryParams, 'unitName', item)
      } else {
        this.$set(this.queryParams, field, item)
      }
      this.getList(this.tabs[this.activeIndex].apiUrl)
    },
  }
}
</script>
<style lang="less" scoped>
.staff-info {
  border-radius: 4px;
  /* 效果样式1 */
  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.08);
  background: linear-gradient(135.00deg, rgba(168, 190, 255, 0.7), rgba(131, 145, 252, 0.7) 100%);

  .active {
    background: linear-gradient(43.88deg, rgba(127, 126, 253, 1), rgba(112, 163, 254, 1) 73%);
    border-radius: 8px;
    color: #ffffff;
  }

  .tab-content {
    position: relative;

    .slide-transition {
      transition: transform 0.3s ease;
    }
  }
}
</style>
